import { render, staticRenderFns } from "./mFinish.vue?vue&type=template&id=200d4809&scoped=true&"
import script from "./mFinish.vue?vue&type=script&lang=js&"
export * from "./mFinish.vue?vue&type=script&lang=js&"
import style0 from "./mFinish.vue?vue&type=style&index=0&id=200d4809&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200d4809",
  null
  
)

export default component.exports